import api from 'api'
import { WORK_ORDER_STATUS_IDS } from 'components/customer-details/content/work-orders/filters/work-order-status-filter/settings'
import { DEFAULT_SORT_RULES_BY_SERVICE_DATE_DESC } from 'components/customer-details/content/work-orders/settings'
import { getWorkOrderListProvidesTags, getWorkOrderListSummaryProvidesTags } from 'components/customer-details/content/work-orders/utils'

import type {
  ListWorkOrdersBody,
  ListWorkOrdersResponseApi,
  SummaryWorkOrdersBody,
  SummaryWorkOrdersResponseApi,
} from 'types/api/work-order/workOrderList'

// The three include flags travel as query params, the rest is the request body.
export type FetchWorkOrderListArgs = ListWorkOrdersBody & {
  includeDisposalTickets?: boolean
  includeExceptions?: boolean
  includeTags?: boolean
  skipCache?: boolean
}

export type FetchWorkOrderListSummaryArgs = SummaryWorkOrdersBody & { skipCache?: boolean }

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    fetchWorkOrderList: build.query<ListWorkOrdersResponseApi, FetchWorkOrderListArgs>({
      providesTags: (result, error, args) => getWorkOrderListProvidesTags(args),
      query: ({
        sortRules,
        statuses = WORK_ORDER_STATUS_IDS,
        includeDisposalTickets = true,
        includeExceptions = true,
        includeDeactivatedServices = true,
        includeTags = false,
        skipCache: _skipCache,
        ...rest
      }) => ({
        url: '/api/v1/core/work-orders/list',
        method: 'POST',
        body: { sortRules, statuses, includeDeactivatedServices, ...rest },
        params: { includeDisposalTickets, includeExceptions, includeTags },
      }),
    }),
    fetchWorkOrderListSummary: build.query<SummaryWorkOrdersResponseApi, FetchWorkOrderListSummaryArgs>({
      providesTags: (result, error, args) => getWorkOrderListSummaryProvidesTags(args),
      query: args => ({
        url: '/api/v1/core/work-orders/list/summary',
        method: 'POST',
        body: { sortRules: [...DEFAULT_SORT_RULES_BY_SERVICE_DATE_DESC], ...args },
      }),
    }),
  }),
})

export const {
  useLazyFetchWorkOrderListQuery,
  useFetchWorkOrderListQuery,
  useLazyFetchWorkOrderListSummaryQuery,
  useFetchWorkOrderListSummaryQuery,
} = extendedApi
